import React, { Component } from 'react';
import _ from 'lodash';

export default class DataTableCell extends Component {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    getValue() {
        try {
            let newData = {
                ...this.props.row,
                __index: this.props.index,
                __allData: this.props.rows
            }
            return _.template(`<%= ${this.props.column.expression} %>`)(newData);
        }
        catch (err) {
            return null;
        }
    }

    render() {
        return (
            <td style={{
                padding: `${this.props.option.paddingVBody}px ${this.props.option.paddingHBody}px`,
                borderLeft: this.props.index === 0 ? `${this.props.option.borderWidthTable}px ${this.props.option.borderStyleTable} ${this.props.option.borderColorTable}` : ``,
                borderBottom: `${this.props.option.borderWidthTable}px ${this.props.option.borderStyleTable} ${this.props.option.borderColorTable}`,
                borderRight: `${this.props.option.borderWidthTable}px ${this.props.option.borderStyleTable} ${this.props.option.borderColorTable}`
            }}>{this.getValue()}</td>
        );
    }
}
